import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const GooglePayIcon = (props: IconProps) => (
  <StyledIcon
    width="61"
    height="24"
    viewBox="0 0 61 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.6709 15.3861H51.707L54.7256 7.809H56.8477L50.3252 22.9994H48.3125L50.7373 17.686L46.457 7.809H48.5791L51.6709 15.3861ZM41.4619 7.46525C42.9046 7.46529 44.0444 7.85929 44.8809 8.63419C45.7173 9.40912 46.1299 10.4916 46.1299 11.8568V18.3637H44.2627V16.8998H44.1777C43.3654 18.1053 42.2979 18.7084 40.9521 18.7084C39.8127 18.7083 38.8428 18.3639 38.0791 17.6752C37.3275 17.0356 36.9036 16.0885 36.9277 15.0922C36.9277 13.9974 37.34 13.1357 38.1523 12.4838C38.9646 11.8321 40.0555 11.5121 41.4131 11.5121C42.5769 11.5121 43.5228 11.7336 44.2744 12.1518V11.6967C44.2743 11.0203 43.9836 10.3807 43.4746 9.9379C42.9533 9.47048 42.2858 9.21232 41.5947 9.21232C40.5037 9.21241 39.6431 9.67991 39.0127 10.6147L37.291 9.51993C38.2124 8.15457 39.607 7.46525 41.4619 7.46525ZM32.2109 2.93693C33.4594 2.91246 34.6717 3.39234 35.5566 4.27775C37.3267 5.95063 37.4354 8.76741 35.7744 10.5756L35.5566 10.7973C34.6475 11.6705 33.5322 12.1136 32.2109 12.1137H28.9854V18.3627H27.0332V2.93693H32.2109ZM41.7139 13.1098C40.9257 13.1098 40.2581 13.3066 39.7246 13.6879C39.2035 14.0691 38.9366 14.5485 38.9365 15.1264C38.9365 15.6429 39.179 16.1231 39.5791 16.4184C40.0155 16.7627 40.5492 16.9472 41.0947 16.935C41.9193 16.935 42.708 16.6026 43.29 16.0121C43.9325 15.3972 44.2597 14.6716 44.2598 13.8354C43.6535 13.3434 42.805 13.0975 41.7139 13.1098ZM28.9854 10.2192H32.2588C32.9862 10.2438 33.6894 9.94811 34.1865 9.41935C35.2051 8.3492 35.1809 6.62741 34.126 5.59415C33.6288 5.10213 32.9621 4.83146 32.2588 4.83146H28.9854V10.2192Z"
      fill="currentColor"
    />
    <path
      d="M22.2526 10.7612C22.2526 10.1585 22.2041 9.55576 22.1071 8.96533H13.875V12.3726H18.5912C18.3972 13.4673 17.7668 14.4514 16.8454 15.0664V17.2805H19.6581C21.3069 15.743 22.2526 13.4673 22.2526 10.7612Z"
      fill="#4285F4"
    />
    <path
      d="M13.8738 19.4202C16.2258 19.4202 18.2141 18.6329 19.6569 17.2799L16.8441 15.0658C16.0561 15.607 15.0498 15.9145 13.8738 15.9145C11.5945 15.9145 9.6668 14.3523 8.97574 12.2612H6.07812V14.5491C7.55724 17.5382 10.5761 19.4202 13.8738 19.4202Z"
      fill="#34A853"
    />
    <path
      d="M8.97542 12.2599C8.61164 11.1652 8.61164 9.97202 8.97542 8.86496V6.58936H6.07735C4.82838 9.08638 4.82838 12.0385 6.07735 14.5355L8.97542 12.2599Z"
      fill="#FBBC04"
    />
    <path
      d="M13.8738 5.21128C15.1226 5.18668 16.3228 5.6664 17.22 6.53975L19.7175 4.00582C18.1293 2.50515 16.044 1.68101 13.8738 1.70561C10.5761 1.70561 7.55724 3.5999 6.07812 6.58895L8.97574 8.87686C9.6668 6.77346 11.5945 5.21128 13.8738 5.21128Z"
      fill="#EA4335"
    />
  </StyledIcon>
)
